
export interface fieldError {
   clientId: string | null,
   index: number | null,
   fieldName: string,
   error: string
}

export interface apiError {
   message: string,
   fieldErrors: fieldError[]
}

export function parseApiError(jsonError: string): apiError {
   if (jsonError) {
      try {
         const je = JSON.parse(jsonError);

         if (Object.prototype.hasOwnProperty.call(je, "errors")) {
            let msg = "";
            const errs: fieldError[] = [];

            for (const field in je.errors) {
               if (Object.prototype.hasOwnProperty.call(je.errors, field)) {
                  const err = (je.errors[field] as string[]).join("\r\n");
                  if (!msg.includes(err)) msg = (msg + '\r\n' + err).trim();

                  const fieldRe = /^\[([0-9]+)\]\.([a-zA-Z]+)$/

                  const fieldMatches = fieldRe.exec(field)

                  if (fieldMatches) {
                     errs.push({
                        clientId: null,
                        index: parseInt(fieldMatches[1]),
                        fieldName: fieldMatches[2],
                        error: err
                     })
                  } else {
                     errs.push({
                        clientId: null,
                        index: null,
                        fieldName: field,
                        error: err
                     })
                  }
               }
            }

            return {
               message: msg,
               fieldErrors: errs
            }
         } else if (Object.prototype.hasOwnProperty.call(je, "error")) {
            return {
               message: je.error,
               fieldErrors: []
            }
         } else {
            // Unknown error
            return {
               message: "Sorry, something went wrong. Please try again later.",
               fieldErrors: []
            }
         }

      } catch (e) {
         return {
            message: jsonError,
            fieldErrors: []
         }
      }
   } else {
      return {
         message: "Something unexpected happened...",
         fieldErrors: []
      }
   }
}

export function getFieldErrorMsg(errs: fieldError[], fieldName: string, clientId: null | string) : null | string {
   if (errs) {
      let err: fieldError | undefined;

      if (clientId)
         err = errs.find(e => e.fieldName == fieldName && e.clientId == clientId);
      else
         err = errs.find(e => e.fieldName == fieldName);

      if (err) {
         return err.error;
      } else {
         return null;
      }
   } else {
      return null;
   }
}

export function hasFieldError(errs: fieldError[], fieldName: string, clientId: null | string): boolean {
   if (getFieldErrorMsg(errs, fieldName, clientId))
      return true;
   else
      return false;
}

export function hasRecordError(errs: fieldError[], clientId: string): boolean {
   if (errs)
      return errs.some(e => e.clientId == clientId);
   else
      return false;
}